module.exports = __webpack_public_path__ + "img/facebook.06b54386.svg";